import { Component, OnInit } from '@angular/core';
import { BadaService } from 'src/app/services/bada.service';
import { VehicleEquipment } from 'src/app/models/vehicle-equipment';
import { Router } from '@angular/router';
import { RoutesPathEnum } from 'src/app/app-routing.module';

@Component({
  selector: 'app-table-versions',
  templateUrl: './table-versions.component.html',
  styleUrls: ['./table-versions.component.css']
})
export class TableVersionsComponent implements OnInit {
  vehicleEquipments: VehicleEquipment[] = [];
  tableColumns: CustomTableColumn[] = [];
  tableDisplayedColumns: string [] = [];
  dataSource: CustomTableDatasource [] [] = [];

  constructor(private badaService: BadaService, private router: Router) { }

  ngOnInit(): void {
    /**
    * Sottoscrizione alle vehicle info nel bada service
    */
    this.badaService.vehicleInfo.subscribe(vehicleInfo => {
      if (vehicleInfo) {
        this.vehicleEquipments = vehicleInfo.allEquipments;

        vehicleInfo.versions.forEach((version, index) => {
          const tableColumn: CustomTableColumn = { index: index, columnDef: `column${index}`, header: version.description, versionCodeAm: version.infocarcodeAM };
          this.tableColumns.push(tableColumn);
        })
        this.tableDisplayedColumns = this.tableColumns.map(tableColumn => tableColumn.columnDef);

        this.vehicleEquipments.forEach(equip => {
          let row: CustomTableDatasource [] = [];
          vehicleInfo.versions.forEach(version => {
            let matchingEquip = null;
            if (version.equipments && version.equipments.length) {
              matchingEquip = !!version.equipments.find(_ => _.code == equip.code);
            }
            row.push({ versionCodeAM: version.infocarcodeAM, equipCode: equip.code, equipDescription: equip.description, equipIsMatching: matchingEquip? true : false });
          })
          this.dataSource.push(row);
        })
      }
    });
  }

  onTableHeaderClick(column: CustomTableColumn) {
    this.badaService.vehicleVersionSelected = this.badaService.vehicleInfo.getValue().versions.find(version => version.infocarcodeAM == column.versionCodeAm);
    this.router.navigate([RoutesPathEnum.VehicileIdentity]);
  }

}


interface CustomTableColumn {
  index: number;
  columnDef: string;
  header: string;
  versionCodeAm: string;
}

interface CustomTableDatasource {
  equipCode: string;
  equipDescription: string;
  equipIsMatching: boolean;
  versionCodeAM: string;
}
